import { render, staticRenderFns } from "./ClaimWizard.vue?vue&type=template&id=59d0046c&scoped=true&"
import script from "./ClaimWizard.vue?vue&type=script&lang=js&"
export * from "./ClaimWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d0046c",
  null
  
)

export default component.exports